import React from "react";

export default function BicyclesPage() {

  return (
    <div>
      Bicycles
    </div>
  );
}
